import {useState, useEffect} from "react";
import {isEmpty} from "lodash";
import {useRequest} from "../../utils/hooks.jsx";
import {constructBudgetObject} from "../../company/CompanyAccountProfile/utils.jsx";

export const useBriefUserData = briefInfo => {
    const [userBooking, setUserBooking] = useState({});

    const [userMe = {}, isLoadingMe, errorMe, fetchMe] = useRequest(
        `/api/users/me/${briefInfo?.userId}`,
        "GET",
        null,
        [briefInfo?.userId],
        !!briefInfo?.userId
    );

    const [companyMe = {}, isLoadingCompany, errorCompany, fetchCompany] = useRequest(
        `/api/companies/info/${userMe?.companyId}`,
        "GET",
        null,
        [userMe?.companyId],
        !!userMe?.companyId
    );

    const [userBudget = [], isLoadingBudget, errorBudget, fetchUserBudget] = useRequest(
        `/api/budget/user/${userMe?.userId}`,
        "GET",
        null,
        [userMe?.userId],
        !!userMe?.userId
    );

    const [services = []] = useRequest(
        `/api/categories/users/${userMe?.userId}`,
        "GET",
        null,
        [userMe?.userId],
        !!userMe?.userId,
        null,
        []
    );

    useEffect(() => {
        if (!isEmpty(userMe)) {
            setUserBooking(me => ({...userMe}));
        }
    }, [userMe]);

    useEffect(() => {
        if (!isEmpty(userBudget)) {
            const budget = constructBudgetObject(userBudget);
            setUserBooking(me => ({...me, budget}));
        }
    }, [userBudget]);

    return {
        userBooking,
        userMe,
        isLoadingMe,
        fetchMe,
        companyMe,
        fetchCompany,
        isLoadingCompany,
        services
    };
};
